"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostVisitor = void 0;
const ast_1 = require("@wapc/widl/ast");
const helpers_1 = require("./helpers");
const utils_1 = require("../utils");
class HostVisitor extends ast_1.BaseVisitor {
    constructor(writer) {
        super(writer);
    }
    visitOperation(context) {
        if (!utils_1.shouldIncludeHostCall(context)) {
            return;
        }
        if (context.config.hostPreamble != true) {
            const className = context.config.hostClassName || "Host";
            this.write(`
      import { hostCall, Result } from "@wapc/as-guest";
      export class ${className} {
      binding: string;
  
      constructor(binding: string = "default") {
        this.binding = binding;
      }\n`);
            context.config.hostPreamble = true;
        }
        this.write(`\n`);
        const operation = context.operation;
        this.write(utils_1.formatComment("  // ", operation.description));
        this.write(`  ${utils_1.camelCase(operation.name.value)}(`);
        operation.parameters.map((param, index) => {
            if (index > 0) {
                this.write(`, `);
            }
            this.write(`${param.name.value}: ${helpers_1.expandType(param.type, true, false)}`);
        });
        const returnType = helpers_1.expandType(operation.type, true, false);
        this.write(`): `);
        const retVoid = helpers_1.isVoid(operation.type);
        if (retVoid) {
            this.write(`Error | null {\n`);
        }
        else {
            this.write(`Result<${returnType}> {\n`);
        }
        this.write(`  `);
        if (operation.parameters.length == 0) {
            this.write(`const result = hostCall(this.binding, ${helpers_1.strQuote(context.namespace.name.value)}, ${helpers_1.strQuote(operation.name.value)}, new ArrayBuffer(0));\n`);
        }
        else if (operation.isUnary()) {
            const unaryParam = operation.parameters[0];
            if (helpers_1.isObject(unaryParam.type)) {
                this.write(`const result = hostCall(this.binding, ${helpers_1.strQuote(context.namespace.name.value)}, ${helpers_1.strQuote(operation.name.value)}, ${operation.unaryOp().name.value}.toBuffer());\n`);
            }
            else {
                this.write(`const sizer = new Sizer();
        ${helpers_1.write("sizer", "", "", unaryParam.name.value, unaryParam.type, false, helpers_1.isReference(operation.annotations))}const ua = new ArrayBuffer(sizer.length);
        const encoder = new Encoder(ua);
        ${helpers_1.write("encoder", "", "", unaryParam.name.value, unaryParam.type, false, helpers_1.isReference(operation.annotations))}`);
                this.write(`const result = hostCall(this.binding, ${helpers_1.strQuote(context.namespace.name.value)}, ${helpers_1.strQuote(operation.name.value)}, ua);\n`);
            }
        }
        else {
            this.write(`const inputArgs = new ${helpers_1.capitalize(operation.name.value)}Args();\n`);
            operation.parameters.map((param) => {
                const paramName = param.name.value;
                this.write(`  inputArgs.${paramName} = ${paramName};\n`);
            });
            this.write(`const result = hostCall(
      this.binding,
      ${helpers_1.strQuote(context.namespace.name.value)},
      ${helpers_1.strQuote(operation.name.value)},
      inputArgs.toBuffer()
    );\n`);
        }
        if (retVoid) {
            this.write(`return result.error()\n`);
        }
        else {
            this.write(`if (!result.isOk) {
        return Result.error<${returnType}>(result.error()!);
      }\n`);
        }
        if (!retVoid) {
            if (helpers_1.isObject(operation.type)) {
                this.write(`    const decoder = new Decoder(result.get());\n`);
                this.write(`    const ret = ${helpers_1.expandType(operation.type, false, helpers_1.isReference(operation.annotations))}.decode(decoder);\n`);
                this.write(`if (decoder.error()) {
          return Result.error<${returnType}>(decoder.error()!)
        }
        return Result.ok(ret);\n`);
            }
            else {
                this.write(`    const decoder = new Decoder(result.get());\n`);
                this.write(`const ${helpers_1.read("payload", operation.type, false, helpers_1.isReference(operation.annotations))}`);
                this.write(`if (decoder.error()) {
          return Result.error<${returnType}>(decoder.error()!)
        }\n`);
                this.write(`  return Result.ok(payload);\n`);
            }
        }
        this.write(`  }\n`);
        super.triggerOperation(context);
    }
    visitAllOperationsAfter(context) {
        if (context.config.hostPreamble == true) {
            this.write(`}\n\n`);
            delete context.config.hostPreamble;
        }
        super.triggerAllOperationsAfter(context);
    }
}
exports.HostVisitor = HostVisitor;
//# sourceMappingURL=host_visitor.js.map